import Header from './component/header/Header' 
import Footer from './component/footer/Footer' 
import Reproductor from './component/player/Reproductor'

const App = () => {
  return (
	<div className="app-container">
		<Header/>
		<main className="main-content">
			<Reproductor></Reproductor>
      	</main>
		<Footer/>
    </div>
  )
}

export default App